export const nullToString = (value: string | null) => {
	return value === null ? '' : value;
};
